import _ from 'lodash';

import {
  UPDATE_NOTIFICATIONS,
  DELETE_NOTIFICATION,
  DELETE_ALL_NOTIFICATIONS,
} from 'stores/types/';

const initialState = {
  data: [],
  total: 0
};

const notifications = ( state = initialState, action ) => {
  switch( action.type ) {
    case UPDATE_NOTIFICATIONS:
      if( _.get( action, 'data.data' ) )
        return {
          data: [...state.data, ...action.data.data],
          total: parseInt( action.data.total )
        };
      return {
        data: [...state.data, action.data],
        total: state.total + 1
      };
    case DELETE_NOTIFICATION:
      let data = _.cloneDeep( state.data );
      const index = _.findIndex( data, { id: action.id } );
      data.splice( index, 1 );
      return { data, total: state.total - 1 };
    case DELETE_ALL_NOTIFICATIONS:
      return initialState;
    default:
      return state;
  }
};

module.exports = notifications;



// WEBPACK FOOTER //
// ./stores/reducers/common/notifications.js